<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="mb-0">
              <i class="fas fa-clock text-warning mr-2" />
              Aprovações de Ponto — Desvios de Horário
            </h4>
            <button
              class="btn btn-sm btn-outline-secondary"
              :disabled="loading"
              @click="fetchPending(1)"
            >
              <i class="fas fa-sync-alt mr-1" /> Atualizar
            </button>
          </div>

          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-5">
                <label class="small text-muted mb-1">Colaborador</label>
                <v-select
                  v-model="filters.user_id"
                  :options="users"
                  label="name"
                  :reduce="u => u.id"
                  placeholder="Todos"
                />
              </div>
              <div class="col-md-3">
                <label class="small text-muted mb-1">Data da batida</label>
                <input
                  v-model="filters.date"
                  type="date"
                  class="form-control"
                >
              </div>
              <div class="col-md-4 d-flex align-items-end">
                <button
                  class="btn btn-primary mr-2"
                  :disabled="loading"
                  @click="fetchPending(1)"
                >
                  <i class="fas fa-filter mr-1" /> Filtrar
                </button>
                <button
                  class="btn btn-outline-secondary"
                  :disabled="loading"
                  @click="limparFiltros"
                >
                  <i class="fas fa-times mr-1" /> Limpar
                </button>
              </div>
            </div>

            <div
              v-if="loading"
              class="text-center text-muted py-4"
            >
              <i class="fas fa-spinner fa-spin mr-2" /> Carregando pendências...
            </div>

            <div
              v-else-if="!pending.length"
              class="text-center text-muted py-4"
            >
              <i class="fas fa-check-circle text-success mr-2" />
              Nenhuma batida pendente de aprovação.
            </div>

            <table
              v-else
              class="table table-hover"
            >
              <thead>
                <tr>
                  <th>Colaborador</th>
                  <th>Jornada</th>
                  <th>Data / Hora batida</th>
                  <th>Início do turno</th>
                  <th>Tipo</th>
                  <th>Origem</th>
                  <th class="text-right">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="check in pending"
                  :key="check.id"
                >
                  <td>{{ (check.user && check.user.name) || ('#' + check.user_id) }}</td>
                  <td>
                    <template v-if="check.journey">
                      <div>{{ check.journey.title || '—' }}</div>
                      <small class="text-muted">
                        <i class="fas fa-sign-in-alt" /> {{ formatTime(check.journey.expected_entry_time) }}
                        &nbsp;<i class="fas fa-sign-out-alt" /> {{ formatTime(check.journey.expected_exit_time) }}
                      </small>
                    </template>
                    <span
                      v-else
                      class="text-muted"
                    >—</span>
                  </td>
                  <td>{{ formatDateTime(check.created_at) }}</td>
                  <td>
                    <span v-if="check.shift_start_date">{{ formatDate(check.shift_start_date) }}</span>
                    <span
                      v-else
                      class="text-muted"
                    >—</span>
                  </td>
                  <td>
                    <span
                      v-if="check.punch_type === 'entry'"
                      class="badge badge-success"
                    >
                      <i class="fas fa-sign-in-alt" /> Entrada
                    </span>
                    <span
                      v-else-if="check.punch_type === 'exit'"
                      class="badge badge-secondary"
                    >
                      <i class="fas fa-sign-out-alt" /> Saída
                    </span>
                    <span
                      v-else
                      class="text-muted"
                    >—</span>
                  </td>
                  <td>
                    <span
                      class="badge"
                      :class="origemClass(check)"
                    >{{ origemLabel(check) }}</span>
                  </td>
                  <td class="text-right">
                    <button
                      class="btn btn-sm btn-outline-success mr-1"
                      @click="abrirModal(check)"
                    >
                      <i class="fas fa-check mr-1" /> Revisar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div
              v-if="meta.last_page > 1"
              class="d-flex justify-content-between align-items-center mt-2"
            >
              <small class="text-muted">{{ meta.total }} pendência(s)</small>
              <div>
                <button
                  class="btn btn-sm btn-outline-secondary mr-1"
                  :disabled="meta.current_page <= 1"
                  @click="fetchPending(meta.current_page - 1)"
                >Anterior</button>
                <span class="mx-2">{{ meta.current_page }} / {{ meta.last_page }}</span>
                <button
                  class="btn btn-sm btn-outline-secondary"
                  :disabled="meta.current_page >= meta.last_page"
                  @click="fetchPending(meta.current_page + 1)"
                >Próxima</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL — Aprovar / Rejeitar (reusa o fluxo do TeamChecks) -->
    <div
      v-if="exibirModal"
      id="modalAprovacao"
      class="modal fade"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fas fa-clock text-warning mr-2" /> Revisar Desvio de Horário
            </h5>
            <button
              type="button"
              class="close"
              @click="fecharModal"
            >
              <span>&times;</span>
            </button>
          </div>

          <div
            v-if="batida"
            class="modal-body p-3"
          >
            <p class="mb-1">
              Batida de <strong>{{ (batida.user && batida.user.name) || ('#' + batida.user_id) }}</strong>
              em <strong>{{ formatDateTime(batida.created_at) }}</strong>
            </p>
            <p
              v-if="batida.journey"
              class="mb-2"
            >
              <small class="text-muted">
                Jornada: <strong>{{ batida.journey.title || '—' }}</strong>
                — entrada <strong>{{ formatTime(batida.journey.expected_entry_time) }}</strong>,
                saída <strong>{{ formatTime(batida.journey.expected_exit_time) }}</strong>
              </small>
            </p>

            <div
              class="btn-group btn-block mb-3"
              role="group"
            >
              <button
                type="button"
                class="btn"
                :class="acao === 'approve' ? 'btn-success' : 'btn-outline-success'"
                @click="acao = 'approve'"
              >
                <i class="fas fa-check mr-1" /> Aprovar (mantém horário)
              </button>
              <button
                type="button"
                class="btn"
                :class="acao === 'reject' ? 'btn-danger' : 'btn-outline-danger'"
                @click="acao = 'reject'"
              >
                <i class="fas fa-times mr-1" /> Rejeitar (corrige horário)
              </button>
            </div>

            <template v-if="acao === 'reject'">
              <div
                v-if="suggestion"
                class="mb-2"
              >
                <small class="text-muted">
                  Horário previsto
                  ({{ suggestion.punch_type === 'entry' ? 'entrada' : 'saída' }}:
                  <strong>{{ suggestion.expected_time }}</strong>):
                </small>
                <button
                  class="btn btn-sm btn-link p-0 ml-1"
                  @click="novoHorario = suggestion.suggested_time"
                >
                  Usar {{ formatSuggestion(suggestion.suggested_time) }}
                </button>
              </div>

              <div class="form-group">
                <label>Novo horário</label>
                <input
                  v-model="novoHorario"
                  type="datetime-local"
                  class="form-control"
                >
              </div>

              <div class="form-group">
                <label>Justificativa</label>
                <textarea
                  v-model="justificativa"
                  class="form-control"
                  rows="3"
                  maxlength="500"
                />
                <small class="text-muted">{{ justificativa.length }}/500</small>
              </div>
            </template>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="fecharModal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!acao || loadingAcao"
              @click="confirmar"
            >
              <i
                v-if="loadingAcao"
                class="fas fa-spinner fa-spin mr-1"
              />
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'DeviationApprovals',
  data() {
    return {
      pending: [],
      meta: { current_page: 1, last_page: 1, total: 0 },
      loading: false,
      users: [],
      filters: { user_id: null, date: '' },
      // modal
      exibirModal: false,
      batida: null,
      acao: null,
      novoHorario: '',
      justificativa: '',
      suggestion: null,
      loadingAcao: false,
    }
  },
  mounted() {
    this.getUsers()
    this.fetchPending(1)
  },
  methods: {
    _jq() {
      return window.jQuery || window.$
    },
    formatDateTime(value) {
      return value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : 'N/A'
    },
    formatDate(value) {
      return value ? moment(value).format('DD/MM/YYYY') : '—'
    },
    formatSuggestion(value) {
      return value ? moment(value).format('DD/MM/YYYY HH:mm') : ''
    },
    formatTime(value) {
      if (!value) return '—'
      // aceita "HH:mm:ss" ou datetime completo
      return value.length <= 8 ? value.slice(0, 5) : moment(value).format('HH:mm')
    },
    origemLabel(check) {
      if (check.remote) return 'Remoto'
      if (check.manual) return 'Manual'
      return 'Presencial'
    },
    origemClass(check) {
      if (check.remote) return 'badge-info'
      if (check.manual) return 'badge-secondary'
      return 'badge-primary'
    },

    getUsers() {
      axios.get(`${this.$store.state.api}users/active`)
        .then(r => { this.users = r.data })
        .catch(e => { this.$message('Erro', e?.response?.data || 'Erro ao carregar colaboradores.', 'error') })
    },

    limparFiltros() {
      this.filters = { user_id: null, date: '' }
      this.fetchPending(1)
    },

    async fetchPending(page) {
      this.loading = true
      try {
        const params = { page: page || 1 }
        if (this.filters.user_id) params.user_id = this.filters.user_id
        if (this.filters.date) params.date = this.filters.date
        const { data } = await axios.get(`${this.$store.state.api}checks/deviations/pending`, {
          params,
        })
        const paginator = data.data || {}
        this.pending = paginator.data || []
        this.meta = {
          current_page: paginator.current_page || 1,
          last_page: paginator.last_page || 1,
          total: paginator.total || 0,
        }
      } catch (e) {
        this.$message('Erro', e?.response?.data?.message || 'Erro ao carregar pendências.', 'error')
      } finally {
        this.loading = false
      }
    },

    abrirModal(check) {
      this.batida = check
      this.acao = null
      this.novoHorario = moment(check.created_at).format('YYYY-MM-DDTHH:mm')
      this.justificativa = ''
      this.suggestion = null
      this.loadingAcao = false
      this.exibirModal = true

      this.$nextTick(() => {
        const jq = this._jq()
        if (jq && jq('#modalAprovacao').length) {
          jq('#modalAprovacao')
            .off('hidden.bs.modal')
            .on('hidden.bs.modal', () => this._reset())
            .modal({ backdrop: 'static', keyboard: false })
            .modal('show')
        }
      })

      this._fetchSuggestion(check.id)
    },

    async _fetchSuggestion(checkId) {
      try {
        const { data } = await axios.get(`${this.$store.state.api}checks/${checkId}/deviation/suggestion`)
        if (data.status === '00') this.suggestion = data
      } catch (_) {
        // silencioso
      }
    },

    fecharModal() {
      const jq = this._jq()
      if (jq && jq('#modalAprovacao').length) jq('#modalAprovacao').off('hidden.bs.modal').modal('hide')
      this._reset()
    },

    _reset() {
      this.exibirModal = false
      this.batida = null
      this.acao = null
      this.novoHorario = ''
      this.justificativa = ''
      this.suggestion = null
      this.loadingAcao = false
    },

    async confirmar() {
      if (!this.acao) return
      if (this.acao === 'approve') {
        await this._aprovar()
      } else {
        await this._rejeitar()
      }
    },

    async _aprovar() {
      this.loadingAcao = true
      try {
        await axios.post(`${this.$store.state.api}checks/${this.batida.id}/deviation/approve`)
        this.$message('Sucesso', 'Desvio aprovado. Horário original mantido.', 'success')
        this.fecharModal()
        this.fetchPending(this.meta.current_page)
      } catch (e) {
        this.$message('Erro', e?.response?.data?.message || 'Erro ao aprovar desvio.', 'error')
      } finally {
        this.loadingAcao = false
      }
    },

    async _rejeitar() {
      if (!this.novoHorario) {
        this.$message('Atenção', 'Informe o novo horário para o ajuste.', 'warning')
        return
      }
      if (!this.justificativa.trim()) {
        this.$message('Atenção', 'Informe a justificativa.', 'warning')
        return
      }

      this.loadingAcao = true
      try {
        const ajustado = moment(this.novoHorario, 'YYYY-MM-DDTHH:mm').format('YYYY-MM-DD HH:mm:ss')
        await axios.post(`${this.$store.state.api}checks/${this.batida.id}/deviation/reject`, {
          adjusted_punched_at: ajustado,
          justification: this.justificativa.trim(),
        })
        this.$message('Sucesso', 'Horário corrigido e desvio registrado.', 'success')
        this.fecharModal()
        this.fetchPending(this.meta.current_page)
      } catch (e) {
        this.$message('Erro', e?.response?.data?.message || 'Erro ao corrigir batida.', 'error')
      } finally {
        this.loadingAcao = false
      }
    },
  },
}
</script>
